import React, { Component } from 'react';
import Header from './shared/header/Header';
import Footer from './shared/footer/Footer';
import Router from './Router';
import PropTypes from "prop-types";
import { hot } from "react-hot-loader";
import ScrollToTop from './shared/scrolltotop/ScrollToTop';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <ScrollToTop>
        <Router/>
        </ScrollToTop>
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default hot(module)(App);

